const React = require('react'),

  moment = require('moment'),
  Line = require('react-chartjs-2').Line,
  annotationPlugin = require('chartjs-plugin-annotation');


function toSection(section, color, yMax) {
  return {
    id: "box-" + section['since'],
    type: 'box',
    drawTime: 'afterDatasetsDraw',
    mode: 'horizontal',
    xScaleID: 'x-axis-0',
    yScaleID: 'y-axis-0',
    xMin: moment(section['since']),
    xMax: moment(section['until']),
    yMax: yMax,
    yMin: 0,
    backgroundColor: color,
    borderWidth: 0,
    borderColor: 'rgba(0, 0, 0, 0)'
  };
}

function splitToSections(dates, values, criticalOccupancy, maxOccupancy) {
  let sections = [];
  let currentSection = {};

  function getLevel(x) {
    if(maxOccupancy && maxOccupancy <= x) return 'max';
    else if(criticalOccupancy && criticalOccupancy <= x) return 'critical';
    else return 'normal';
  }

  for(let i = 0; i < dates.length; i++){
    if(!currentSection.level) {
      currentSection.level = getLevel(values[i]);
      currentSection.since = dates[i];
    } else {
      let nextLevel = getLevel(values[i]);
      if(currentSection.level !== nextLevel) {
        currentSection.until = moment((dates[i-1] + dates[i]) / 2);
        sections.push(currentSection);
        currentSection = {};
        currentSection.level = nextLevel;
        if(sections.length > 0) currentSection.since = moment((dates[i-1] + dates[i]) / 2);
        else currentSection.since = dates[i];
      }
    }
  }

  currentSection.until = dates[dates.length - 1];
  sections.push(currentSection)

  return sections;
}


class OccupancyChart extends React.Component {
  render() {
    let data = this.props.data;
    if (!data) { return 'Loading'; }

    let backgroundColor = '#b4bbc7';
    let textColor = '#343b47';

    let values = data.data.map(v => Math.round(v.occupancy));
    let dates = data.data.map(d => moment(d.time));
    let chartData = {
      labels: dates,
      datasets: [{
        data: values,
        fill: 'start',
        backgroundColor: backgroundColor,
        borderColor: textColor
      }]
    }

    let yMax = Math.round(Math.max(...values) * 1.1);
    let sections = splitToSections(dates, values, data.criticalOccupancy, data.maxOccupancy);
    let options = {
      responsive: true,

      annotation: {
        annotations: sections.filter(x => x.level === 'max').map(
          section => toSection(section, 'rgba(230, 87, 28, 0.5)', yMax)
        ).concat(
            sections.filter(x => x.level === 'critical').map(
            section => toSection(section, 'rgba(253, 182, 43, 0.5)', yMax)
          )
        ).concat(
            sections.filter(x => x.level === 'normal').map(
            section => toSection(section, 'rgba(58, 180, 73, 0.5)', yMax)
          )
        )
      },

      // maintainAspectRatio: false,
      scaleFontColor: textColor,
      legend: { display: false },
      scales: {
        xAxes: [{
          type: 'time',
          gridLines: { display: false },
          time: {
            unit: 'hour',
          },
          ticks: {
            autoSkip: true,
            maxRotation: 0,
            minRotation: 0
          }
        }],
        yAxes: [{
          gridLines: { display: false },
          ticks: {
            beginAtZero: true,
            min: 0,
            max: yMax
          }
        }]
      },
    };

    let chartKey = String(dates.length) + '-' + String(yMax);

    return <Line key={chartKey} data={chartData} options={options} height={180} />;
  }
}

export default OccupancyChart;
